import { injectable } from "inversify";
import QARepository from "../../../domain/repositories/qa.repository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/error.entity";
import QAAgentEntity from "../../../domain/entities/qa_agent.entity";
import QAQuestionEntity from "../../../domain/entities/qa_question.entity";
import SearchResultEntity from "../../../domain/entities/search_result.entity";
import searchAgentsApiImpl from "./api/search_agents.api.impl";
import getAgentByIdApiImpl from "./api/get_agent_by_id.api.impl";
import updateQuestionApiImpl from "./api/update_question.api.impl";
import createAgentApiImpl from "./api/create_agent.api.impl";
import deleteQuestionApiImpl from "./api/delete_question.api.impl";
import deleteAgentApiImpl from "./api/delete_agent.api.impl";
import QACategoryEntity from "../../../domain/entities/qa_category.entity";
import createQuestionApiImpl from "./api/create_question.api.impl";
import updateAgentApiImpl from "./api/update_agent.api.impl";
import createCategoryApiImpl from "./api/create_qa_category.api.impl";
import deleteCategoryApiImpl from "./api/delete_category.api.impl";
import updateCategoryApiImpl from "./api/update_qa_category.api.impl";
import MasterItemEntity from "../../../domain/entities/master_item.entity";
import searchOpTypesApiImpl from "./api/search_op_types.api.impl";

@injectable()
class QARepositoryImpl implements QARepository {
    searchOpTypes = (_: { query: string | undefined; page: number; itemsPerPage: number; }): Promise<Either<ErrorEntity, SearchResultEntity<MasterItemEntity>>> => searchOpTypesApiImpl(_);
    //category
    addCategory = (qaCategory: QACategoryEntity): Promise<Either<ErrorEntity, QACategoryEntity>> => createCategoryApiImpl(qaCategory);
    updateCategory = (qaCategory: QACategoryEntity): Promise<Either<ErrorEntity, QACategoryEntity>> => updateCategoryApiImpl(qaCategory);
    deleteCategory = (id: string): Promise<Either<ErrorEntity, void>> => deleteCategoryApiImpl(id);

    //agent
    deleteAgent = (id: string): Promise<Either<ErrorEntity, void>> => deleteAgentApiImpl(id);
    updateAgent = (formData: FormData): Promise<Either<ErrorEntity, QAAgentEntity>> =>
        updateAgentApiImpl(formData);
          createAgent = async (data: FormData): Promise<Either<ErrorEntity, QAAgentEntity>> => createAgentApiImpl(data);
    searchAgents = (_: { query: string, page: number, itemsPerPage: number, operationId?: string }): Promise<Either<ErrorEntity, SearchResultEntity<QAAgentEntity>>> => searchAgentsApiImpl(_);
    getAgentById = async (id: string): Promise<Either<ErrorEntity, QAAgentEntity>> => getAgentByIdApiImpl(id);

    //questions
    addQuestionToAgent = async (_: { category: QACategoryEntity, question: QAQuestionEntity }): Promise<Either<ErrorEntity, QAQuestionEntity>> => createQuestionApiImpl(_);
    deleteQuestionFromAgent = async (questionId: string): Promise<Either<ErrorEntity, void>> => deleteQuestionApiImpl(questionId);
    updateQuestionFromAgent = (question: QAQuestionEntity): Promise<Either<ErrorEntity, QAQuestionEntity>> => updateQuestionApiImpl(question);

}

export default QARepositoryImpl;